import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    CREATE_SUMMARY_REPORT_OBJECTS: createActionType(FULL_NAMESPACE, "CREATE_SUMMARY_REPORT_OBJECTS"),
    CREATE_SUMMARY_REPORT_OBJECTS_COMPLETED: createActionType(FULL_NAMESPACE, "CREATE_SUMMARY_REPORT_OBJECTS_COMPLETED"),
    CREATE_SUMMARY_REPORT_OBJECTS_REJECTED: createActionType(FULL_NAMESPACE, "CREATE_SUMMARY_REPORT_OBJECTS_REJECTED")
};
